<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h4>Nova Clínica</h4>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-2">
            <label for="descricao">Pagante</label>
            <select class="form-select" v-model="state.clinica.destaque">
              <option value="SIM">Sim</option>
              <option value="NAO">Não</option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <label for="nome">Nome</label>
            <input
              id="nome"
              type="text"
              class="form-control"
              placeholder="Digite um nome:"
              v-model="state.clinica.nome.value"
            />
            <span v-if="state.clinica.nome.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
          <div class="col-md-2">
            <label for="telefone">Telefone</label>
            <input
              id="telefone"
              type="text"
              class="form-control"
              placeholder="Digite um telefone:"
              v-mask-phone.br
              v-model="state.clinica.telefone.value"
            />
            <span v-if="state.clinica.telefone.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <label for="endereco">E-mail</label>
            <input
              id="endereco"
              type="email"
              class="form-control"
              placeholder="Digite um email:"
              v-model="state.clinica.email.value"
            />
            <span v-if="state.clinica.email.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
          <div class="col-md-3">
            <label for="endereco">CNPJ</label>
            <input
              id="endereco"
              type="text"
              class="form-control"
              placeholder="Digite o CNPJ:"
              v-mask-cnpj
              v-model="state.clinica.cnpj.value"
            />
            <span v-if="state.clinica.cnpj.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <label for="endereco">Endereço</label>
            <input
              id="endereco"
              type="text"
              class="form-control"
              placeholder="Digite um endereço:"
              v-model="state.clinica.endereco.value"
            />
            <span v-if="state.clinica.endereco.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
          <div class="col-md-2">
            <label for="numero">Número</label>
            <input
              id="numero"
              type="text"
              class="form-control"
              placeholder="Digite um endereço:"
              v-model="state.clinica.numero.value"
            />
            <span v-if="state.clinica.numero.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <label for="bairro">Bairro</label>
            <input
              id="bairro"
              type="text"
              class="form-control"
              placeholder="Digite um endereço:"
              v-model="state.clinica.bairro.value"
            />
            <span v-if="state.clinica.bairro.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
          <div class="col-md-2">
            <label for="cep">CEP</label>
            <input
              id="cep"
              type="text"
              v-model="state.clinica.cep.value"
              class="form-control"
              placeholder="Digite o CEP:"
              v-mask-cep
            />
            <span v-if="state.clinica.endereco.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <label>Estado</label>
            <select
              class="form-select"
              @change="fetchCidade($event.target.value)"
              v-model="state.clinica.estado_id"
            >
              >
              <option
                :value="estado.id"
                v-for="estado in state.estados"
                :key="estado.id"
              >
                {{ estado.nome }}
              </option>
            </select>
          </div>
          <div class="col-md-3">
            <label for="numero">Cidade</label>
            <select class="form-select" v-model="state.clinica.cidade_id.value">
              <option
                :value="cidade.id"
                v-for="cidade in state.cidades"
                :key="cidade.id"
              >
                {{ cidade.nome }}
              </option>
            </select>
            <span v-if="state.clinica.cidade_id.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label for="descricao">Descrição</label>
            <textarea
              id="descricao"
              class="form-control"
              v-model="state.clinica.descricao.value"
            ></textarea>
            <span v-if="state.clinica.descricao.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label>Imagem</label>
            <div class="inputFile">
              <span class="arquivo">Selecionar foto</span>
              <input
                type="file"
                class="form-control"
                @change="adicionarImagem"
                v-if="state.clinica.destaque == 'NAO'"
              />
              <input
                type="file"
                class="form-control"
                @change="adicionarImagens"
                v-else
                multiple
              />
              <span v-if="state.erro_imagem" class="text-danger"
                >Este campo é obrigatório</span
              >
            </div>
          </div>
        </div>
        <div v-for="imagem in state.imagens" :key="imagem.id">
          <img :src="imagem.imagem" class="imagem" />
          <button
            type="button"
            class="btn_deletar_imagem"
            @click="removerImagem(imagem.id)"
          >
            X<!--
              <img
                src="../../../public/img/btn_deletar.png"
                class="img_deletar"
              />-->
          </button>
        </div>

        <div class="btns_right">
          <button @click="salvarClinica" type="button" class="btn_save">
            Salvar
          </button>
          <router-link to="/clinicas">
            <button type="button" class="btn_cancel">Cancelar</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import services from "../../services";
import { useStorage } from "vue3-storage";
export default {
  setup() {
    const router = useRouter();
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const state = reactive({
      id: "",
      clinica: {
        nome: {
          value: "",
          error: false,
        },
        telefone: {
          value: "",
          error: false,
        },
        cep: {
          value: "",
          error: false,
        },
        endereco: {
          value: "",
          error: false,
        },
        bairro: {
          value: "",
          error: false,
        },
        numero: {
          value: "",
          error: false,
        },
        cidade_id: {
          value: "",
          error: false,
        },
        estado_id: "",
        descricao: {
          value: "",
          error: false,
        },
        email: {
          value: "",
          error: false,
        },
        cnpj: {
          value: "",
          error: false,
        },

        destaque: "NAO",
      },
      erro_imagem: false,
      imagens: [],
      imagens_remover: [],
      estados: [],
      cidades: [],
    });
    onMounted(() => {
      fetchEstados();
      if (router.currentRoute._value.params.id != undefined) {
        fetchClinica();
      }
    });
    async function fetchClinica() {
      try {
        const { data } = await services.clinica.getById({
          id: router.currentRoute._value.params.id,
          token,
        });
        state.clinica.id = data.id;
        state.clinica.destaque = data.destaque;
        state.clinica.nome.value = data.nome;
        state.clinica.cnpj.value = data.cnpj;
        state.clinica.telefone.value = data.telefone;
        state.clinica.email.value = data.email;
        state.clinica.cep.value = data.cep;
        state.clinica.endereco.value = data.endereco;
        state.clinica.bairro.value = data.bairro;
        state.clinica.numero.value = data.numero;
        state.clinica.cidade_id.value = data.cidade_id;
        state.clinica.descricao.value = data.descricao;
        fetchCidade(data.estado.id);
        state.clinica.estado_id = data.estado.id;
        state.imagens = data.imagens;
      } catch (error) {
        console.log(error);
      }
    }
    async function fetchEstados() {
      try {
        const { data } = await services.estado.getAll({
          token,
        });
        state.estados = data;
      } catch (error) {
        console.log(error);
      }
    }
    async function fetchCidade(estado_id) {
      try {
        const { data } = await services.estado.getCidades({
          estado_id,
          token,
        });
        state.cidades = data.data;
      } catch (error) {
        console.log(error);
      }
    }
    async function salvarClinica() {
      var erro_validacao = false;

      if (state.clinica.nome.value.length == 0) {
        state.clinica.nome.error = true;
        erro_validacao = true;
      }
      if (state.clinica.telefone.value.length == 0) {
        state.clinica.telefone.error = true;
        erro_validacao = true;
      }
      if (state.clinica.cep.value.length == 0) {
        state.clinica.cep.error = true;
        erro_validacao = true;
      }
      if (state.clinica.endereco.value.length == 0) {
        state.clinica.endereco.error = true;
        erro_validacao = true;
      }
      if (state.clinica.bairro.value.length == 0) {
        state.clinica.bairro.error = true;
        erro_validacao = true;
      }
      if (state.clinica.numero.value.length == 0) {
        state.clinica.numero.error = true;
        erro_validacao = true;
      }
      if (state.clinica.cidade_id.value.length == 0) {
        state.clinica.cidade_id.error = true;
        erro_validacao = true;
      }
      if (state.clinica.descricao.value.length == 0) {
        state.clinica.descricao.error = true;
        erro_validacao = true;
      }

      if (erro_validacao == true) {
        return;
      }

      let clinica = {};
      clinica.nome = state.clinica.nome.value;
      clinica.destaque = state.clinica.destaque;
      clinica.endereco = state.clinica.endereco.value;
      clinica.numero = state.clinica.numero.value;
      clinica.bairro = state.clinica.bairro.value;
      clinica.cep = state.clinica.cep.value;
      clinica.cnpj = state.clinica.cnpj.value;
      clinica.email = state.clinica.email.value;
      clinica.cidade_id = state.clinica.cidade_id.value;
      var value = state.clinica.telefone.value;
      var clean = value.replace(/[^0-9,]*/g, "");
      state.clinica.telefone.value = clean;
      clinica.telefone = clean;
      clinica.descricao = state.clinica.descricao.value;

      if (!state.clinica.id) {
        await services.clinica
          .save({ clinica, token })
          .then(async (obj) => {
            for (let i = 0; i < state.imagens.length; i++) {
              if (
                state.imagens[i].file != null &&
                state.imagens[i].file != undefined
              ) {
                var formImagens = new FormData();
                formImagens.append("clinica_id", obj.data.id);
                console.log(state.imagens[i].file);
                formImagens.append("imagem", state.imagens[i].file);
                await services.imagem_clinica.save({ formImagens, token });
              }
            }
            router.push({ name: "Clinicas" });
          })
          .catch((error) => {
            console.log(error);
            var valores = Object.values(error.response.data.errors);
            alert(valores);
          });
      } else {
        clinica.id = state.clinica.id;
        // Deletar imagens antes de atualizar
        await services.imagem_clinica.delete({
          imagens: state.imagens_remover,
          token,
        });
        // Atualizar a clínica
        await services.clinica
          .update({ clinica, token })
          .then(async (data) => {
            console.log(data);
            // Verificar se há imagens para cadastrar
            for (let i = 0; i < state.imagens.length; i++) {
              if (
                state.imagens[i].file != null &&
                state.imagens[i].file != undefined
              ) {
                var formImagens = new FormData();
                formImagens.append("clinica_id", clinica.id);
                formImagens.append("imagem", state.imagens[i].file);
                await services.imagem_clinica.save({ formImagens, token });
              }
            }
            router.push({ name: "Clinicas" });
          })
          .catch((error) => {
            console.log(error);
            var valores = Object.values(error.response.data.errors);
            alert(valores);
          });
      }
    }

    async function adicionarImagem(event) {
      if (state.imagens.length < 1) {
        for (let index = 0; index < event.target.files.length; index++) {
          const element = event.target.files[index];
          var objImagem = new Object();
          objImagem.id = index;
          objImagem.file = element;
          objImagem.imagem = URL.createObjectURL(element);
          state.imagens.push(objImagem);
        }
      } else {
        alert("Limite de 1 imagem para clinica não pagante.");
      }
    }

    async function adicionarImagens(event) {
      for (let index = 0; index < event.target.files.length; index++) {
        const element = event.target.files[index];
        var objImagem = new Object();
        objImagem.id = index;
        objImagem.file = element;
        objImagem.imagem = URL.createObjectURL(element);
        state.imagens.push(objImagem);
      }
    }

    async function removerImagem(index) {
      for (let i = 0; i < state.imagens.length; i++) {
        if (state.imagens[i].id == index) {
          if (
            state.imagens[i].file == null ||
            state.imagens[i].file == undefined
          ) {
            state.imagens_remover.push(index);
          }
          state.imagens.splice(i, 1);
        }
      }
    }
    return {
      salvarClinica,
      router,
      state,
      fetchCidade,
      adicionarImagem,
      adicionarImagens,
      removerImagem,
    };
  },
};
</script>
<style scoped>
h4 {
  color: #000;
}

label {
  color: #000;
  font-size: 12pt;
  margin-bottom: 0;
  margin-top: 5px;
}

input {
  border: solid 1px #000;
}

input:focus {
  border: solid 1px #47b0a9;
}

select {
  border: solid 1px #000;
}

select:focus {
  border: solid 1px #47b0a9;
}

.btns_right {
  text-align: right;
}

.btn_save {
  padding: 5px;
  width: 100px;
  background: #00a000;
  border: solid 2px #000;
  border-radius: 5px;
  transition: 0.2s;
}

.btn_save:hover {
  background: #008000;
}

.btn_cancel {
  padding: 5px;
  width: 100px;
  background: #c4342d;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}

.btn_cancel:hover {
  background: #8f0303;
}

.card {
  border: solid 2px #000;
  border-radius: 10px;
  background-color: #fff;
}

textarea {
  resize: none;
  border: solid 1px #000;
}

textarea:focus {
  border: solid 1px #47b0a9;
}

.imagem {
  width: 300px;
  height: 200px;
  object-fit: cover;
  margin-top: 2rem;
  border: solid 2px #4bafa9;
  border-radius: 3px;
}

.btn_deletar_imagem {
  margin-left: 10px;
  height: 30px;
  width: 30px;
  margin-top: 2rem;
  background: #c4342d;
  color: #000;
  border: solid 1px #000;
  border-radius: 5px;
  transition: 0.2s;
}

.btn_deletar_imagem:hover {
  background: #8f0303;
  border: solid 1px #000;
}

.inputFile {
  width: 100%;
  height: 60px;
  position: relative;
  overflow: hidden;
  border: #000 solid 1px;
  border-radius: 10px;
  margin-bottom: 15px;
}

.inputFile input {
  opacity: 0;
  filter: alpha(opacity=0);
  right: 0;
  padding-top: 5px;
  z-index: 2;
  height: 80px;
  font-size: 100px;
  color: #000;
}

.arquivo {
  position: absolute;
  top: 15px;
  color: #000;
  margin-left: 15px;
  font-weight: 700;
}
</style>